var BULLET = '•';
export default (function (value) {
  if (value === null || typeof value === 'undefined') {
    return null;
  }

  return value.replace(/\*/g, BULLET);
});
//# sourceMappingURL=index.js.map